module.exports = __webpack_public_path__ + "static/media/linkedin.d9049f46.svg";